var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list',{attrs:{"mode":"prediction","items":_vm.predictions},on:{"load":_vm.onLoad,"delete":_vm.onDelete}})
}
var staticRenderFns = []

export { render, staticRenderFns }